
import { Prop, Component, Vue, Emit } from 'vue-property-decorator'
import { CalculationnNum } from '@/utils/tool'
@Component({
  name: 'ListItem'
})
export default class ListItem extends Vue {
  @Prop({
    default: () => ({}),
    type: Object
  })
  item!: any

  private defaultImg = 'http://qnimg.zowoyoo.com/img/84826/1680261061590.png'

  CalculationnNum = CalculationnNum

  @Emit('click')
  handleClick () {
    return ''
  }

  // 打开地图
  private clickMap = () => {
    let latitude = 0
    let longitude = 0
    if (this.item) {
      latitude = this.item.latitude || 0
      longitude = this.item.longitude || 0
    }
    if (latitude && longitude) {
      const url = `http://api.map.baidu.com/geocoder?location=${latitude},${longitude}&coord_type=bd09ll&output=html&src=zowoyoo`
      window.open(url, '_blank')
    }
  }
}
